<template>
  <div class="account-setting">
    <Block title="微信支付商家号">
      <el-form v-bind="formOptions" :model="form" ref="form">
        <el-form-item prop="merchantId" label="商户号"><el-input v-model="form.merchantId" /></el-form-item>
        <el-form-item prop="merchantAbbreviation" label="商户简称"><el-input v-model="form.merchantAbbreviation" /></el-form-item>
        <el-form-item prop="enterpriseName" label="企业全称"><el-input v-model="form.enterpriseName" /></el-form-item>
        <el-form-item prop="privateKey" label="商户API私钥"
          ><el-input v-model="form.privateKey" type="textarea"
        /></el-form-item>
        <el-form-item prop="merchantSerialNumber" label="商户证书序列号"><el-input v-model="form.merchantSerialNumber" /></el-form-item>
        <el-form-item prop="apiV3Key" label="商户APIV3密钥"
          ><el-input v-model="form.apiV3Key" type="textarea"
        /></el-form-item>
      </el-form>
    </Block>
    <Block title="服务费方式">
      <el-form v-bind="formOptions" :model="form">
        <el-form-item label="服务费">
          <el-radio-group v-model="form.serviceEnable">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务费方式">
          <el-radio-group disabled v-model="form.serviceType">
            <el-radio :label="1">根据订单</el-radio>
            <el-radio :label="2">根据房源数</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="border: 1px solid lightgray; padding: 16px 0 0">
          <el-form-item label="单次订单服务费">
            <el-input-number :step="0.01" :min="0" step-strictly v-model="form.onceFee" /><span style="margin-left: 8px">元</span>
          </el-form-item>
          <el-form-item label="余额不足提醒">
            <el-input-number :step="0.01" :min="0" step-strictly v-model="form.balanceThreshold" /><span style="margin-left: 8px">元</span>
          </el-form-item>
        </div>
      </el-form>
    </Block>
    <div class="footer">
      <el-button @click="save" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import Block from "./block.vue";
import { mapActions } from "vuex";
export default {
  name: "AccountSetting",
  components: { Block },
  data() {
    const required = () => ({
      validator: (rule, value, cb) =>
        value ? cb() : cb(new Error("必填")),
      required: true,
      trigger: "blur",
    })
    return {
      form: {
        merchantId: "", // 商户号
        merchantAbbreviation: "", // 商户简称
        enterpriseName: "", // 企业全称
        privateKey: "", // 商户API私钥
        merchantSerialNumber: "", // 商户证书序列号
        apiV3Key: "", // 商户APIV3密钥
        serviceEnable: 0, // 是否启用 0禁用 1启用
        serviceType: 1, // 服务费方式 1订单 2房源
        onceFee: 5, // 单次订单服务费
        balanceThreshold: 50, // 余额阈值
        areaCode: "", // 区域编码?
      },
      formOptions: {
        labelWidth: "120px",
        rules: {
          merchantId: [required()],
          merchantAbbreviation: [required()],
          enterpriseName: [required()],
          privateKey: [required()],
          merchantSerialNumber: [required()],
          apiV3Key: [required()],
        },
      },
    };
  },
  methods: {
    ...mapActions(["fetchData"]),
    async save() {
      if(this.form.serviceEnable == 1){
        const valid = await this.$refs.form.validate();
        if(!valid) return;
      }else{
        this.$refs.form.clearValidate();
      }
      this.saveData();
    },
    saveData(){
      this.fetchData({
        url: '保存配置',
        method: 'post',
        params: {
          ...this.form,
          privateKey: window.btoa(this.form.privateKey)
        },
        headers: { 'Content-Type': 'application/json' }
      }).then((data) => {
        if(data){
          this.$message.success('操作成功');
          this.getData();
        }else{
          this.$message.error('操作失败');
        }
      });
    },
    getData(){
      this.fetchData({
        url: '查询配置',
        method: 'get',
      }).then(data => {
        data && (this.form = data);
      })
    }
  },
  created(){
    this.getData();
  }
};
</script>

<style lang="less" scoped>
.account-setting {
  .el-input-number :deep(.el-input-number__increase) {
    border-left: 1px solid #c0c4cc !important;
  }
  .footer {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>